import { useState } from "react";
import { earnings, whatsappUrl } from "../mock";
import { Coins, Calculator } from "lucide-react";
import { Slider } from "./ui/slider";

export default function Earnings() {
  const [clients, setClients] = useState([50]);
  const [invoice, setInvoice] = useState([500]);
  const [commission, setCommission] = useState([4]);

  const monthly = Math.round(clients[0] * invoice[0] * (commission[0] / 100));

  return (
    <section id="ganhos" className="py-20 bg-slate-50 relative">
      <div className="max-w-6xl mx-auto px-4 md:px-8">
        <div className="text-center">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-emerald-100 text-emerald-700 text-xs font-semibold mb-4">
            <Coins className="w-3.5 h-3.5" /> Seus Ganhos
          </div>
          <h2 className="text-slate-900 text-3xl md:text-5xl font-extrabold leading-tight">
            Múltiplas Fontes de <span className="green-gradient-text">Renda Recorrente</span>
          </h2>
          <p className="mt-5 text-slate-600 max-w-2xl mx-auto">
            Como Licenciado iGreen, você tem acesso a diferentes formas de ganhar dinheiro todos os meses, construindo uma renda que cresce com o tempo.
          </p>
        </div>

        <div className="mt-12 grid md:grid-cols-2 lg:grid-cols-4 gap-5">
          {earnings.map((e) => (
            <div
              key={e.title}
              className="rounded-2xl bg-white border border-slate-200 p-6 text-center hover:border-emerald-400 hover:shadow-xl transition-all"
            >
              <div className="text-4xl md:text-5xl font-extrabold gold-gradient-text">{e.value}</div>
              <h3 className="mt-3 text-slate-900 font-bold text-lg">{e.title}</h3>
              <p className="mt-2 text-slate-600 text-sm leading-relaxed">{e.desc}</p>
            </div>
          ))}
        </div>

        <div className="mt-12 rounded-3xl bg-white border border-slate-200 p-6 md:p-10 shadow-sm">
          <div className="flex items-center gap-2 text-emerald-700 mb-6">
            <Calculator className="w-5 h-5" />
            <h3 className="text-slate-900 font-bold text-xl">Simulação de Ganhos Mensais</h3>
          </div>
          <div className="grid md:grid-cols-3 gap-6">
            <div>
              <div className="text-3xl font-extrabold text-emerald-600">{clients[0]}</div>
              <div className="text-slate-500 text-sm mb-3">Clientes ativos</div>
              <Slider value={clients} onValueChange={setClients} min={1} max={500} step={1} />
            </div>
            <div>
              <div className="text-3xl font-extrabold text-emerald-600">R${invoice[0]}</div>
              <div className="text-slate-500 text-sm mb-3">Fatura média</div>
              <Slider value={invoice} onValueChange={setInvoice} min={100} max={5000} step={50} />
            </div>
            <div>
              <div className="text-3xl font-extrabold text-emerald-600">{commission[0]}%</div>
              <div className="text-slate-500 text-sm mb-3">Sua comissão</div>
              <Slider value={commission} onValueChange={setCommission} min={1} max={5} step={0.1} />
            </div>
          </div>
          <div className="mt-8 rounded-2xl bg-gradient-to-r from-emerald-600 to-emerald-500 p-6 md:p-8 text-center text-white">
            <div className="text-emerald-50 text-sm">Ganho mensal estimado:</div>
            <div className="text-4xl md:text-5xl font-extrabold mt-2">
              R$ {monthly.toLocaleString("pt-BR")}/mês
            </div>
            <p className="text-emerald-100 text-xs mt-3">*Valores ilustrativos. Seus ganhos dependem do seu esforço e dedicação.</p>
          </div>
          <div className="mt-6 text-center">
            <a href={whatsappUrl} target="_blank" rel="noreferrer" className="btn-gold inline-flex items-center gap-2 px-6 py-3 rounded-xl text-sm">
              Chamar no WhatsApp
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
